// extracted by mini-css-extract-plugin
export default {"wrapper":"Services_wrapper__m3eA8"};